import includes from 'lodash/includes';
import deliveryConstants from '../../../constants/deliveryConstants';

function getTradeplaceItemsWithUndeliverableQuantity(deliveries = [], items = []) {
  const tradeplaceItemsWithUndeliverableQuantity = [];
  deliveries.forEach((delivery) => {
    if (delivery.type === deliveryConstants.TRADEPLACE) {
      const deliveryItems = items.filter(item => includes(delivery.itemIds, item.id));
      deliveryItems.forEach((item) => {
        if (item.quantity > 1) {
          tradeplaceItemsWithUndeliverableQuantity.push(item);
        }
      });
    }
  });
  return tradeplaceItemsWithUndeliverableQuantity;
}

export default getTradeplaceItemsWithUndeliverableQuantity;
